import { ReactElement, useContext, useMemo } from 'react';
import { ProductFull } from '../types/catalog';
import { CategoriesContext } from '../App';

export type ShowKey =
    | 'description'
    | 'advantages'
    | 'videos'
    | 'files'
    | 'specs'
    | 'usage'
    | 'logistics'
    | 'software'
    | 'complects'
    | 'complectations'
    | 'designFeatures'
    | 'analogs'
    | 'related';

type ShowProps = {
    [key in ShowKey]: boolean | null;
};

export interface ProductRenderProps {
    product: ProductFull | null;
    show: ShowProps;
}

interface ProductProps {
    render: (props: ProductRenderProps) => ReactElement | null;
}

export function Product({ render }: ProductProps) {
    const { product } = useContext(CategoriesContext);
    const show = useMemo(
        () => ({
            description: !!product,
            advantages: product && !!product.advantages,
            videos: product && product.videos && product.videos.length > 0,
            files: product && product.files.length > 0,
            specs: product && product.etim && product.etim.features && product.etim.features.length > 0,
            usage: product && product.leftPeriod && product.leftPeriod.length > 0,
            logistics: product && product.logisticParams.length > 0,
            software: product && product.software.length > 0,
            complects: product && product.complects.length > 0,
            complectations: product && product.complects.length === 0 && !!product.complectations,
            designFeatures: product && product.designFeatures.length > 0,
            analogs: product && product.analogs.length > 0,
            related: product && product.related.length > 0,
        }),
        [product],
    );

    const Render = render;
    return <Render product={product} show={show} />;
}

export default Product;
